(function () {
// jQuery 4 polyfill.
(function($) {
    if (!$.type) {
        var class2type = {};
        "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" ").forEach(function(name) {
            class2type["[object " + name + "]"] = name.toLowerCase();
        });
        $.type = function(obj) {
            if (obj == null) return obj + "";
            return typeof obj === "object" || typeof obj === "function" ? class2type[Object.prototype.toString.call(obj)] || "object" : typeof obj;
        };
    }
    if (!$.isArray) $.isArray = Array.isArray;
    if (!$.isFunction) $.isFunction = function(obj) {
        return typeof obj === "function";
    };
    if (!$.trim) $.trim = function(str) {
        return str == null ? "" : (str + "").trim();
    };
})(jQuery);
// Sitewide Custom JS (legacy host/CMS).
(function($, Drupal1) {
    Drupal1.behaviors.tsFeedingAmericaMain = {
        attach: function(context, settings) {
            promosLogic();
            assignLastClass();
            interrupterToggle();
            interrupterAction();
            interrupterShow();
            renderRecentItemBoxes();
            $(once('section-img-hover', '.section-img-hover')).click(function(e) {
                e.preventDefault();
                window.location = $(this).parent().find('a').attr('href');
            });
            const searchToggleMap = {
                '#util_search_expand': '#util_search_form_box',
                '#util_test_search_expand': '#util_test_search_form_box',
                '#google_search_expand': '#google_search_form_box'
            };
            const searchToggleSelector = Object.keys(searchToggleMap).join(',');
            const searchTargetSelector = Object.values(searchToggleMap).join(',');
            $(once('util-search-expand', searchToggleSelector)).on('click', function(e) {
                e.preventDefault();
                const $toggle = $(this);
                const targetSelector = searchToggleMap['#' + this.id];
                if (!targetSelector) return;
                const $target = $(targetSelector);
                const isOpening = !$target.hasClass('opened');
                // Close all search UIs first.
                $(searchToggleSelector).removeClass('on');
                $(searchTargetSelector).removeClass('opened');
                // Re-open only the clicked toggle's mapped target.
                if (isOpening) {
                    $toggle.addClass('on');
                    $target.addClass('opened');
                    manageHeaderOpenMenus('search');
                    window.setTimeout(function() {
                        $target.find('form.gsc-search-box input.gsc-input').first().trigger('focus');
                    }, 0);
                }
                if ($('#main-navigation').hasClass('mobile-menu-open')) $('.fa-menu-toggle').trigger('click');
            });
            $(once('util-search-escape', document)).on('keyup', function(e) {
                if (e.key === 'Escape' || e.keyCode === 27) {
                    $(searchToggleSelector).removeClass('on');
                    $(searchTargetSelector).removeClass('opened');
                }
            });
            $(once('util-sign-up-expand', '#util_sign_up_expand')).click(function(e) {
                e.preventDefault();
                $(this).toggleClass('on');
                $('#util_sign_up_form_box').toggleClass('opened').find('input[type=email]').focus();
                manageHeaderOpenMenus('sign_up');
                $(document).keyup(function(f) {
                    if (f.keyCode === 27) {
                        $('#util_sign_up_expand').removeClass('on').focus();
                        $('#util_sign_up_form_box').removeClass('opened');
                    }
                });
            });
            $(once('navbar-toggle', '#mainmenu button.navbar-toggle')).click(function() {
                var $nav1 = $('#nav1');
                var opened = $nav1.hasClass('opened');
                manageHeaderOpenMenus('nav1');
                if (false == opened) $nav1.hide(); // Set to hide for animate toggle
                $nav1.animate({
                    height: 'toggle'
                }, 400, function() {
                    $nav1.toggleClass('opened').css('display', '').css('overflow', '');
                });
            });
            function manageHeaderOpenMenus(current) {
                var menuItems = {
                    search: {
                        links: [
                            'util_search_expand',
                            'util_test_search_expand',
                            'google_search_expand'
                        ],
                        boxes: [
                            'util_search_form_box',
                            'util_test_search_form_box',
                            'google_search_form_box'
                        ]
                    },
                    sign_up: {
                        links: [
                            'util_sign_up_expand'
                        ],
                        boxes: [
                            'util_sign_up_form_box'
                        ]
                    },
                    nav1: {
                        links: [],
                        boxes: [
                            'nav1'
                        ]
                    }
                };
                delete menuItems[current];
                for(var key in menuItems)if (menuItems.hasOwnProperty(key)) {
                    var elm = menuItems[key];
                    elm.links.forEach(function(link) {
                        $('#' + link).removeClass('on');
                    });
                    elm.boxes.forEach(function(box) {
                        $('#' + box).removeClass('opened');
                    });
                }
            }
            /**
       * Hides the secondary promos if primary promos are present. (primary & secondary denote the order of importance.
       *
       * Relies on the following html markup:
       *
       * <div class="promos">
       *     <div class="primary-promos">
       *         <div class="promo"></div>
       *     </div>
       *     <div class="secondary-promos">
       *         <div class="promo"></div>
       *     </div>
       * </div>
       *
       * Assumes secondary Promos are hidden with css by default
       */ function promosLogic() {
                var $promosBlock = $('.promos');
                if ($promosBlock.length > 0) $promosBlock.each(function() {
                    var $primaryPromos = $(this).find('.primary-promos');
                    var $secondaryPromos = $(this).find('.secondary-promos');
                    if ($primaryPromos.length === 0 || $secondaryPromos.length === 0) ;
                    else if ($primaryPromos.children('.promo').length > 0) $secondaryPromos.hide();
                    else {
                        $primaryPromos.hide();
                        $secondaryPromos.show();
                    }
                });
            }
            /**
       * Assigns the class .last-child to the last promo that appears in the right column
       */ function assignLastClass() {
                var $rightColumn = $('.column-2');
                if ($rightColumn.length > 0) {
                    const $sidebarPromos = $rightColumn.find('.sidebar-promo-box:visible');
                    if ($sidebarPromos.length > 0) $sidebarPromos.last().addClass('last-child');
                }
            }
            function interrupterToggle() {
                var $promos = $('.interrupter');
                if ($promos.length > 0) $promos.each(function() {
                    var $promo = $(this);
                    $promo.find('.int-btn-open').on('click', function(e) {
                        e.preventDefault();
                        $promo.removeClass('closed').addClass('open').parent().removeClass('closed').addClass('open');
                    });
                    $promo.find('.int-btn-close').on('click', function(e) {
                        e.preventDefault();
                        if ($promo.hasClass('open')) {
                            $promo.removeClass('open').addClass('closed').parent().removeClass('open').addClass('closed');
                            $('body').focus();
                            var faDataLayer3 = {};
                            faDataLayer3['event'] = 'modal_close';
                            faDataLayer3['modal_type'] = $('.interrupter h2, .interrupter h3, .interrupter h4').text();
                            window.dataLayer.push(faDataLayer3);
                        }
                    });
                    $(document).keyup(function(e) {
                        if (e.keyCode === 27) $promo.find('.int-btn-close').trigger('click');
                    });
                    $('.ts-pop-up__close').on('click', function(e) {
                        $promo.find('.int-btn-close').trigger('click');
                    });
                });
            }
            function interrupterAction() {
                $(once('interrupter-button', '.interrupter button[type="submit"]')).click(function() {
                    faSetCookie('session_interrupter_status', 'action_taken');
                    var faDataLayer2 = {};
                    faDataLayer2['event'] = 'modal_submit';
                    faDataLayer2['modal_type'] = $('.interrupter h2, .interrupter h3, .interrupter h4').text();
                    window.dataLayer.push(faDataLayer2);
                });
            }
            function navAccessibility(navLinks) {
                // Removes titles from nav links if they are the same as the link text. The duplicate links and titles are both
                // read by some screen readers.
                $(navLinks).each(function() {
                    var linkText = $(this).text();
                    var linkTitle = $(this).attr('title');
                    if (linkText == linkTitle) $(this).removeAttr('title');
                });
            }
            navAccessibility($('.footer_nav_redesign a'));
            navAccessibility($('.footer_links a'));
            function interrupterShow() {
                // Init
                var $body = $('body');
                var $promos = $body.find('.interrupter');
                // Processing
                if ($promos.length > 0) {
                    var status = faGetCookie('session_interrupter_status');
                    // Check if interrupter needs to be suppressed
                    if (status == 'action_taken' || $('#nointerrupter').length) {
                        $promos.remove();
                        return;
                    }
                    $('.fa-donation-form-wrapper').each(function() {
                        var promoVal = $(this).data('onsite-promo');
                        if (promoVal) $(this).find('input[name="oa_onsite_promo"]').val(promoVal);
                    });
                    const params = new URLSearchParams(location.search);
                    params.get('utm_source') ? $('input[name="utm_source"]').val(params.get('utm_source')) : $('input[name="utm_source"]').remove();
                    params.get('utm_medium') ? $('input[name="utm_medium"]').val(params.get('utm_medium')) : $('input[name="utm_medium"]').remove();
                    params.get('utm_campaign') ? $('input[name="utm_campaign"]').val(params.get('utm_campaign')) : $('input[name="utm_campaign"]').remove();
                    // Loop through promos
                    $promos.each(function() {
                        var $promo = $(this);
                        var source = null;
                        var timeDelay = 0;
                        var open = true;
                        if ($promo.hasClass('donated-media')) {
                            source = 'donated-media';
                            timeDelay = 10;
                        } else if ($promo.hasClass('organic-search')) {
                            source = 'organic-search';
                            timeDelay = 10;
                        } else if ($promo.hasClass('referral')) {
                            source = 'referral';
                            timeDelay = 0.001;
                        } else if ($promo.hasClass('direct')) {
                            source = 'direct';
                            timeDelay = 10;
                        }
                        // Remove newsletter while holiday is active.
                        if ($promo.hasClass('holiday')) {
                            $body.find('.interrupter.newsletter').parent().remove();
                            var otherValField = $(once('donation-level-amount', '#donation-level-amount'));
                            otherValField.each(function() {
                                otherValField.keyup(function() {
                                    var otherVal = otherValField[0].value, intVal = parseFloat(otherVal);
                                    if (otherVal.length > 0) {
                                        $('#other-donation-level').attr('disabled', false);
                                        otherValField.addClass('active');
                                        $('.interrupter.holiday input[type=radio]').prop('checked', false);
                                        $('#other-donation-level')[0].value = intVal;
                                        $('.interrupter.holiday label').removeClass('checked');
                                    }
                                });
                                $('.interrupter.holiday label').click(function() {
                                    $('.interrupter.holiday label').removeClass('checked');
                                    $(this).addClass('checked');
                                    otherValField[0].value = '';
                                    otherValField.attr('value', '');
                                    $('#other-donation-level')[0].value = '';
                                    $('#other-donation-level').attr('disabled', true);
                                    otherValField.removeClass('active');
                                });
                            });
                        }
                        // Process configurable delay.
                        var delay = $promo.data('block-delay');
                        if (Array.isArray(delay) && delay.length) for(var i = 0; i < delay.length; ++i){
                            var regexp = new RegExp('^' + delay[i][0].replace('*', '.*') + '$');
                            if (location.pathname.match(regexp)) {
                                source = 'block-delay';
                                timeDelay = delay[i][1];
                            }
                        }
                        if (timeDelay > 0) {
                            // Check if active session
                            if (status == 'active') {
                                open = false;
                                timeDelay = 0;
                            }
                            window.setTimeout(function() {
                                if (open) {
                                    $promo.removeClass('closed').addClass('open').parent().removeClass('closed').addClass('open');
                                    $promo.show().parent().show();
                                    $promo[0].focus();
                                    // Set interrupter cookie.
                                    faSetCookie('session_interrupter_status', 'active', 7);
                                    var faDataLayer = {};
                                    faDataLayer['event'] = 'modal_view';
                                    faDataLayer['modal_type'] = $('.interrupter h2, .interrupter h3, .interrupter h4').text();
                                    window.dataLayer.push(faDataLayer);
                                }
                            }, timeDelay * 1000);
                        }
                    });
                }
            }
            function renderRecentItemBoxes() {
                if ($('body.expand-news').length) ;
                else {
                    var lists = [
                        '#recent_news_boxes>a.recent_news_item'
                    ];
                    var layout = [
                        [
                            'one'
                        ],
                        [
                            'two',
                            'two'
                        ],
                        [
                            'three',
                            'three',
                            'three'
                        ],
                        [
                            'four',
                            'four',
                            'four',
                            'four'
                        ],
                        [
                            'two',
                            'two',
                            'three',
                            'three',
                            'three'
                        ],
                        [
                            'three',
                            'three',
                            'three',
                            'three',
                            'three',
                            'three'
                        ],
                        [
                            'two',
                            'two',
                            'two',
                            'two',
                            'three',
                            'three',
                            'three'
                        ],
                        [
                            'four',
                            'four',
                            'four',
                            'four',
                            'four',
                            'four',
                            'four',
                            'four'
                        ],
                        [
                            'three',
                            'three',
                            'three',
                            'three',
                            'three',
                            'three',
                            'three',
                            'three',
                            'three'
                        ],
                        [
                            'two',
                            'two',
                            'four',
                            'four',
                            'four',
                            'four',
                            'four',
                            'four',
                            'four',
                            'four'
                        ]
                    ];
                    for(var i = 0; i < lists.length; i++){
                        var $list = $(lists[i]), len = $list.length;
                        if (len > 0) $list.each(function(index) {
                            $(this).addClass(layout[len - 1][index]);
                        });
                    }
                }
            }
            $(window).scroll(function() {
                var distanceY = window.pageYOffset || document.documentElement.scrollTop, shrinkOn = 300, $header = $(document.querySelector("header"));
                if (distanceY > shrinkOn) $header.addClass("smaller");
                else $header.removeClass("smaller");
                $('.navbar-collapse').removeClass('opened');
            });
            // End Legacy JS.
            // Begin New TS JS.
            $(once('block-local-tasks-block', '.user-logged-in .block-local-tasks-block')).prepend('<div class="show-hide"><span></span></div>');
            $(once('show-hide', '.block-local-tasks-block .show-hide')).click(function() {
                $(this).parent().toggleClass('active');
            });
            $(once('messages', '.messages')).click(function() {
                $(this).fadeOut();
            });
            var faCity = $('.node--type-job-opportunity .field--name-field-city .field__item').text();
            var faState = $('.node--type-job-opportunity .field--name-field-state .field__item').text();
            $(once('field-food-bank', '.node--type-job-opportunity .field--name-field-food-bank .field__item')).append('<br>' + faCity + ', ' + faState);
            if (!$('.column-2 .section-nav > .menu-element').hasClass('menu-element--active-trail')) $('.column-2 .section-nav > .menu-element').addClass('no-active-path');
            $(once('view-footer', '.view-promotions-active .view-footer')).prependTo('.view-promotions-active .pager');
            $(once('field-recent-items', '.field--name-field-recent-items .node--view-mode-related-news-listing-item')).each(function() {
                $(this).find('.field--name-field-thumb').prependTo($(this).parent());
            });
            $(once('recent-news-items', '.page-node-type-landing-page .recent-news-items')).appendTo('.region.region-content');
            $('.alink a[href$="' + window.location.pathname + '"]').parent().addClass('active');
            $('.video-embed-field-lazy-play').each(function() {
                $(this).replaceWith('<button class="video-embed-field-lazy-play" aria-label="Play video"></button>');
            });
            $(once('watchVid', '.watchVid')).click(function(e) {
                // Swap the lightweight image for the heavy JavaScript.
                e.preventDefault();
                $('.watchVid').each(function() {
                    var $el = $(this), $vid = $el.closest("article").find(".lightbox-content .client-story-video-lazy");
                    $vid.html($vid.data('client-story-video-lazy'));
                });
            });
            $(once('hosted-video', '.hosted-video video')).each(function() {
                var el = $(this).closest('.why-i-partner-story');
                el.find('.paragraph--type--sidebar-image, .field--name-field-thumb').prepend('<a class="play-vid" href="#"><img loading="lazy" src="/themes/custom/ts_feeding_america/images/icons/playbuttonwhite.png" class="video-play-button" alt="Play Video" border="0"></a>');
                el.find('.field--name-field-video').find('article').attr('tabindex', '-1').prepend('<a class="close-button" href="#">Close</a>');
                $('.play-vid').click(function(e) {
                    e.preventDefault();
                    var es = $(this).closest(".why-i-partner-story");
                    es.find('.field--name-field-video').hide().addClass('active').fadeIn(300).end().find('article').attr('tabindex', '0').focus().end().find('video')[0].play();
                    $('.close-button').click(function(f) {
                        f.preventDefault();
                        es.find('.field--name-field-video').removeClass('active').end().find('article').attr('tabindex', '-1').blur().end().find('video')[0].pause();
                    });
                    $(document).keyup(function(g) {
                        if (g.key == 'Escape') $('.close-button').trigger('click');
                    });
                });
            });
            $(once('field-featured-blog-post', '.field--name-field-featured-blog-post')).each(function() {
                var el = $(this), title = el.find('.field--name-field-display-title').text();
                el.find('img').attr('alt', title.trim());
            });
            $(once('blog-date-wrapper', '.view-blog-listing .views-exposed-form > .form--inline')).each(function() {
                const $form = $(this);
                const $itemsToWrap = $form.find(".form-item-field-news-date-value, .form-item-field-news-date-value-1, .form-item-field-tags-target-id, .form-actions");
                if ($itemsToWrap.length) $itemsToWrap.wrapAll('<div class="date-set-wrapper flex flex-wrap justify-center gap-[8px] flex-row items-center"></div>');
                $form.find('.date-set-wrapper').prepend('<div class="date-group-label w-full md:w-auto text-center">Filter by Published Date: </div>');
            });
            $(once('header-2', '.paragraph--type--two-up-partner-block .field--name-field-blog-title, .paragraph--type--two-up-partner-block .field--name-field-partner-title, .footer_nav_redesign .footer-head')).each(function() {
                $(this).find('a').wrapInner('<h2>');
            });
            // Alpha sort exposed filter on /about-us/careers/network-jobs
            var options = $('#views-exposed-form-network-jobs-listing-block-1 #edit-title option[value!=""]');
            var arr = options.map(function(_, o) {
                return {
                    t: $(o).text(),
                    v: o.value
                };
            }).get();
            arr.sort(function(o1, o2) {
                return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0;
            });
            options.each(function(i, o) {
                o.value = arr[i].v;
                $(o).text(arr[i].t);
            });
            // Thank a Food Bank hero random quote scripting.
            if ($('.view-thank-a-food-bank').length > 0) {
                function shuffle(array) {
                    var i = array.length, j = 0, temp;
                    while(i--){
                        j = Math.floor(Math.random() * (i + 1));
                        // swap randomly chosen element with current element
                        temp = array[i];
                        array[i] = array[j];
                        array[j] = temp;
                    }
                    return array;
                }
                $(once('view-thank-a-food-bank', '.view-thank-a-food-bank')).each(function() {
                    var quoteOwners = $('.view-thank-a-food-bank .view-content .quote-owner .value').map(function() {
                        return $(this).text();
                    }).get(), quoteTexts = $('.view-thank-a-food-bank .view-content .quote-text .value').map(function() {
                        return $(this).text().trim();
                    }).get();
                    var ranNums = shuffle(Array.from(Array(quoteTexts.length).keys()));
                    $(once('random-thanks', '.random-thanks .thanks p')).eq(0).text(quoteTexts[ranNums[0]]);
                    $(once('random-thanks', '.random-thanks .name')).eq(0).text(function() {
                        $(this).text(quoteOwners[ranNums[0]]);
                    });
                    $(once('random-thanks2', '.random-thanks .thanks p')).eq(1).text(quoteTexts[ranNums[1]]);
                    $(once('random-thanks2', '.random-thanks .name')).eq(1).text(function() {
                        $(this).text(quoteOwners[ranNums[1]]);
                    });
                    $(once('random-thanks3', '.random-thanks .thanks p')).eq(2).text(quoteTexts[ranNums[2]]);
                    $(once('random-thanks3', '.random-thanks .name')).eq(2).text(function() {
                        $(this).text(quoteOwners[ranNums[2]]);
                    });
                });
                $('textarea.form-control').focus(function() {
                    jQuery(this).removeAttr('placeholder');
                });
            }
            $('#util_donate_button a,#util_test_donate_button a').on('focus', function(e) {
                $(this).closest('.util_donate_dropdown').addClass('show');
            });
            $('#util_donate_button a,#util_test_donate_button a').on('blur', function(e) {
                $(this).closest('.util_donate_dropdown').toggleClass('show');
            });
            var surveyID = $('.field--name-field-survey-id').text();
            var questionID = $('.field--name-field-question-id').text();
            if (surveyID.length > 0 && questionID.length > 0) {
                var counterUrl = '//secure.feedingamerica.org/site/SPageServer/?pagename=GetSurveyResults&pgwrap=n&survey_id=' + surveyID + '&question_id=' + questionID + '&callback=?';
                $.ajax({
                    dataType: 'jsonp',
                    jsonp: "callback",
                    success: function(data) {
                        var numResponses = $(data.results).find('p:eq(1)').html();
                        $('.field--name-field-before-number').append('<strong>' + numResponses + '</strong>');
                    },
                    url: counterUrl
                });
            }
            // Fix 3rd-party tracking images without alts.
            $('img:not([alt])').attr('alt', '');
            /**
       * Hides the 'Learn More' link from screen readers and keyboard
       * navigation for specific components.
       *
       * Ideally these attributes could be set in the WYSIWYG but CKEditor is
       * having issues white listing attributes so this is a workaround.
       */ function hideScreenReaderLink() {
                const ctaLinks = context.querySelectorAll('.cta .cta-blurb');
                if (ctaLinks.length > 0) ctaLinks.forEach((ctaLink)=>{
                    const lastLink = ctaLink.querySelector('a:last-child');
                    const lastLinkText = lastLink?.innerText.toLowerCase();
                    if (lastLink && lastLinkText) // Check if lastLink contains the string 'Learn More'.
                    {
                        if (lastLinkText.includes('learn more')) {
                            lastLink.setAttribute('aria-hidden', 'true');
                            lastLink.setAttribute('tabindex', '-1');
                        }
                    }
                });
            }
            hideScreenReaderLink();
            // Universal Opt-Out Mechanism.
            function uoom() {
                window.nvtag_callbacks = window.nvtag_callbacks || {};
                window.nvtag_callbacks.alterPost = window.nvtag_callbacks.alterPost || [];
                window.nvtag_callbacks.alterPost.push(function(args) {
                    if (navigator.globalPrivacyControl === true) args.data.oa_global_privacy = "true";
                });
            }
            uoom();
            // Define external domains to exclude from processing
            const domains = [
                'feedingamerica.org',
                'feeding-america.pantheonsite.io',
                'feeding-america.localhost'
            ];
            const svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="11.3" fill="none" viewBox="0 0 17 16"><path fill="#DE7C00" d="M2.278 16c-.49 0-.908-.174-1.256-.522A1.712 1.712 0 0 1 .5 14.222V1.778c0-.49.174-.908.522-1.256A1.712 1.712 0 0 1 2.278 0H8.5v1.778H2.278v12.444h12.444V8H16.5v6.222c0 .49-.174.908-.522 1.256a1.712 1.712 0 0 1-1.256.522H2.278Zm4.178-4.711L5.21 10.044l8.267-8.266h-3.2V0H16.5v6.222h-1.778v-3.2L6.456 11.29Z"/></svg>';
            // Function to check if a link is internal
            function isInternalLink(href) {
                try {
                    const url = new URL(href, window.location.origin);
                    // If the protocol is not http or https, consider it internal
                    if (![
                        'http:',
                        'https:'
                    ].includes(url.protocol)) return true;
                    // Check if the hostname matches or ends with any of the domains
                    const linkHostname = url.hostname;
                    if (linkHostname === window.location.hostname || domains.some((domain)=>linkHostname.endsWith(domain))) return true;
                    return false;
                } catch (e) {
                    // If the URL cannot be parsed, assume it's internal
                    return true;
                }
            }
            function processExternalLinks(context) {
                const list = context instanceof Element && context.matches('a:not([data-external-link-processed])') ? [
                    context
                ] : context instanceof Element ? context.querySelectorAll('a:not([data-external-link-processed])') : [];
                for (const link of list){
                    link.setAttribute('data-external-link-processed', 'true');
                    if (link.classList.contains('btn') || link.classList.contains('button')) continue;
                    const href = link.getAttribute('href');
                    if (!href) continue;
                    const excluded = [
                        'mailto:',
                        'tel:',
                        'javascript:',
                        'ftp:',
                        'data:'
                    ];
                    if (href === '#' || excluded.some((p)=>href.startsWith(p))) continue;
                    if (!isInternalLink(href)) {
                        if (!link.hasAttribute('target')) link.setAttribute('target', '_blank');
                        if (!link.hasAttribute('rel')) link.setAttribute('rel', 'noopener');
                        const containsHeading = link.querySelector('h1, h2, h3, h4, h5, h6') !== null;
                        const hasOnlyText = link.children.length === 0 && link.textContent.trim() === link.innerHTML.trim();
                        if (containsHeading || hasOnlyText) {
                            link.insertAdjacentHTML('beforeend', '&nbsp;' + svgIcon);
                            const svgElement = link.querySelector('svg');
                            if (svgElement) svgElement.classList.add(link.closest('p') ? 'external-link-icon-small' : 'external-link-icon');
                        }
                        const existingAriaLabel = link.getAttribute('aria-label') || '';
                        if (!existingAriaLabel.includes('(opens in a new tab)')) {
                            const ariaLabel = existingAriaLabel || link.textContent.trim();
                            link.setAttribute('aria-label', `${ariaLabel} (opens in a new tab)`);
                        }
                    }
                }
            }
            const mainContent = document.getElementById('main-content');
            if (mainContent) {
                processExternalLinks(mainContent);
                if (!window.tsFaExternalLinksObserverStarted) {
                    window.tsFaExternalLinksObserverStarted = true;
                    window.tsFaExternalLinksObserver = new MutationObserver((mutationsList)=>{
                        mutationsList.forEach((mutation)=>{
                            mutation.addedNodes.forEach((node)=>{
                                if (node.nodeType === 1) processExternalLinks(node);
                            });
                        });
                    });
                    window.tsFaExternalLinksObserver.observe(mainContent, {
                        childList: true,
                        subtree: true
                    });
                }
            }
            // Move the donor drive script to be a conditional.
            const donorDriveProgramID = "1545-100";
            const donorDriveBaseURL = "teamfeed.feedingamerica.org";
            // Check if the donorDriveButton exists.
            const donorDriveButton = document.querySelector(`button[data-program-id='${donorDriveProgramID}'],
           a[data-program-id='${donorDriveProgramID}'],
           a[href*='${donorDriveBaseURL}'][href*='&programID=${donorDriveProgramID}'][href*='fuseaction=embedDonate.modalEvent']`);
            if (donorDriveButton) {
                // Create and load the script dynamically
                const script = document.createElement("script");
                script.src = "https://teamfeed.feedingamerica.org/resources/js/embed-donate.js?v=20240627151859";
                script.defer = true;
                script.setAttribute("data-program-id", donorDriveProgramID);
                document.body.appendChild(script);
            }
            // ─────────────────────────────────────────────
            // SHARED MODAL TRIGGER
            // Works for: small-icon-card (food-bank-finder, snap-lookup)
            //            video-modal-paragraph
            // Trigger:   any listed class triggers
            // Finds:     .fa-modal-wrapper siblings.
            // ─────────────────────────────────────────────
            $(once('fa-modal', 'h3.food-bank-finder a, h3.snap-lookup a, a.video-trigger')).on('click', function(e) {
                e.preventDefault();
                // Find nearest siblingwith .fa-modal-wrapper.
                var $modalWrapper = $(this).closest('.modal-paragraph').siblings('.fa-modal-wrapper');
                $modalWrapper.addClass('active').fadeIn();
                if (!$('.fa-modal-background').length) $('body').append('<div class="fa-modal-background"></div>');
                $('.fa-modal-background').fadeIn();
                function closeModal() {
                    $modalWrapper.fadeOut(function() {
                        $(this).find('iframe').each(function() {
                            $(this).attr('src', $(this).attr('src'));
                        });
                        $(this).find('form').trigger('reset');
                        $(this).find('.fbf-results-box').empty();
                        $(this).removeClass('active');
                    });
                    $('.fa-modal-background').fadeOut(function() {
                        $(this).remove();
                    });
                }
                $(once('close-modal', '.fa-modal-wrapper.active .close-modal')).on('click', function(e) {
                    e.preventDefault();
                    closeModal();
                });
                $(document).off('keyup.fa-modal').on('keyup.fa-modal', function(e) {
                    if (e.keyCode === 27) closeModal();
                });
                $('.fa-modal-background').off('click').on('click', function() {
                    closeModal();
                });
            });
            // Check if user prefers reduced motion
            const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
            function isInViewport(el) {
                const rect = el.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                return rect.top <= windowHeight * 0.9 && rect.bottom >= 0;
            }
            jQuery.easing.easeOutSlowEnd = function(x, t, b, c, d) {
                t /= d;
                return c * (1 - Math.pow(1 - t, 9)) + b;
            };
            // Initialize all stats: store number, reset to 0
            $('.card-wrapper.simple_stat .stat').each(function() {
                const $stat = $(this);
                const $h3 = $stat.find('h3');
                const fullText = $h3.text().trim();
                const match = fullText.match(/^([^0-9]*)([0-9,]*\.?[0-9]*)(.*)$/);
                const prefix = match[1];
                const numericValue = parseFloat(match[2].replace(/,/g, ''));
                const suffix = match[3];
                const decimalPlaces = (match[2].split('.')[1] || '').length;
                $h3.data('prefix', prefix);
                $h3.data('targetNumber', numericValue);
                $h3.data('suffix', suffix);
                $h3.data('decimalPlaces', decimalPlaces);
                if (prefersReducedMotion) {
                    $h3.text(prefix + numericValue.toLocaleString(undefined, {
                        minimumFractionDigits: decimalPlaces,
                        maximumFractionDigits: decimalPlaces
                    }) + suffix);
                    $stat.data('animated', true);
                } else {
                    $h3.text(`0${suffix}`);
                    $stat.data('animated', false);
                }
            });
            function animateStats() {
                if (prefersReducedMotion) return;
                $('.card-wrapper.simple_stat .stat').each(function() {
                    const $stat = $(this);
                    const $h3 = $stat.find('h3');
                    if (!$stat.data('animated') && isInViewport(this)) {
                        $stat.data('animated', true);
                        // Pick easing based on number size
                        const easingType = $h3.data('targetNumber') < 10 && $h3.data('decimalPlaces') === 0 ? 'linear' : 'easeOutSlowEnd';
                        $({
                            countNum: 0
                        }).animate({
                            countNum: $h3.data('targetNumber')
                        }, {
                            duration: 2500,
                            easing: easingType,
                            step: function(now) {
                                $h3.text($h3.data('prefix') + now.toLocaleString(undefined, {
                                    minimumFractionDigits: $h3.data('decimalPlaces'),
                                    maximumFractionDigits: $h3.data('decimalPlaces')
                                }) + $h3.data('suffix'));
                            },
                            complete: function() {
                                $h3.text($h3.data('prefix') + $h3.data('targetNumber').toLocaleString(undefined, {
                                    minimumFractionDigits: $h3.data('decimalPlaces'),
                                    maximumFractionDigits: $h3.data('decimalPlaces')
                                }) + $h3.data('suffix'));
                            }
                        });
                    }
                });
            }
            $(window).on('scroll resize', animateStats);
            animateStats();
            // Use prefers-reduced-motion to pause autoplay videos.
            const videos = once('pause-video-handling', 'video[autoplay]', context);
            // Pause automatically if reduced motion is preferred
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) videos.forEach(function(video) {
                video.pause();
                video.removeAttribute('autoplay');
            });
            // Manual pause on `a.pause-video` click
            once('pause-video-click', 'a.pause-video', context).forEach(function(link) {
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    videos.forEach(function(video) {
                        if (video.paused) {
                            video.play();
                            link.textContent = 'Pause Video';
                        } else {
                            video.pause();
                            link.textContent = 'Play Video';
                        }
                    });
                });
            });
        // End New TS JS.
        } // attach
    }; // tsFeedingAmerica
})(jQuery, Drupal);

})();
//# sourceMappingURL=main.js.map
